import React from "react";
import { Outlet, useLocation } from "react-router";
import { useSelector } from "../../../../../../shared/src/store";
import { trans } from "../../../../../../shared/src/i18n/translate";
import { useInnerPageHooks } from "../../../../../../shared/src/layouts/useInnerPageHooks";
import { useMobileSidebarCloseOnMenuClick } from "../../../../../../shared/src/layouts/useMobileSidebarCloseOnMenuClick";
import { InnerPageRoot } from "../../../../../../shared/src/layouts/MobileSidebarChrome";
import { ROUTES } from "../../../../../../shared/src/constants";
import { getHubRoute } from "../../../../../../shared/src/handlers";
import { useAuthLayout } from "../../../../../../shared/src/hooks/useAuthLayout";
import { HUB_SIDEBAR_WIDTH_COLLAPSED } from "../../../../../../shared/src/constants/breakpoints";

import PageTop, { faWrench } from "../../../../../../shared/src/components/blocks/PageTop";
import SidebarLateral from "../../../../../../shared/src/components/blocks/SidebarLateral";
import CentralArea from "../../../../../../shared/src/components/blocks/CentralArea";
import { SidebarMenuItem } from "../../../../../../shared/src/components/blocks/SidebarLateral/types";
import { whiteLabelSideMenuBuilder } from "../../../components/menu/side/Builder";

import { DEFAULT_SIDEBAR_LOGO } from "../../../../../../shared/src/constants/assets";
import { useSmartNavigate } from "../../../../../../shared/src/smartNav/useSmartNavigate";
import { useRouteFlagMenuFilter } from "../../../../../../shared/src/smartNav/useRouteFlagMenuFilter";
import type { TReducers } from "../../../../../../shared/src/store/reducers";

import { FixedPageTopWrapper } from "./styles";

const toSidebarMenuItems = (items: any[]): SidebarMenuItem[] =>
  items.map((item) => ({
    title: item.title,
    icon: item.icon,
    path: item.path,
    active: item.active,
    onClick: item.onClick,
    isSubMenu: item.isSubMenu,
    subMenuItems: item.subMenuItems,
    accordionOpen: item.accordionOpen,
  }));

export const InnerPage = (): React.JSX.Element => {
  const {
    user,
    isSidebarOpen,
    setIsSidebarOpen,
    menuTopItems,
    isFormPage,
  } = useInnerPageHooks();
  const { logoUrlWhiteNoLabel, sidebarTopLogoCollapsedUrl } = useAuthLayout();
  const smartNavigate = useSmartNavigate();
  const routerLocation = useLocation();
  const featureType = useSelector((state: TReducers) =>
    state.auth.permissions?.features?.map((feature) => feature.code)
  );
  const filterMenuItems = useRouteFlagMenuFilter();
  const menuItems = filterMenuItems(whiteLabelSideMenuBuilder.build(routerLocation.pathname, featureType));

  useMobileSidebarCloseOnMenuClick(setIsSidebarOpen);

  const TOP_MENU_ITEMS = [
    {
      title: trans("Configurações"),
      icon: faWrench,
      path: getHubRoute(ROUTES.HUB.USER_CONFIG),
    },
  ];

  const pageTopUser = {
    ...user,
    company: { ...user.company, name: menuTopItems.userSection.company },
  };

  return (
    <InnerPageRoot>
      <SidebarLateral
        menuItems={toSidebarMenuItems(menuItems)}
        isOpen={isSidebarOpen}
        onToggle={setIsSidebarOpen}
        logo={DEFAULT_SIDEBAR_LOGO}
        collapsedWidth={HUB_SIDEBAR_WIDTH_COLLAPSED}
        topLogo={{
          expanded: logoUrlWhiteNoLabel,
          collapsed: sidebarTopLogoCollapsedUrl,
          onClick: () => smartNavigate(getHubRoute(ROUTES.HUB.DASHBOARD)),
        }}
      />
      <FixedPageTopWrapper $isSidebarOpen={isSidebarOpen}>
        <PageTop
          user={pageTopUser}
          logoutAction={menuTopItems.userSection.logoutAction}
          menuItems={TOP_MENU_ITEMS}
        />
      </FixedPageTopWrapper>
      <CentralArea isOpen={isSidebarOpen} isFormPage={isFormPage}>
        <Outlet />
      </CentralArea>
    </InnerPageRoot>
  );
};
